import { render, staticRenderFns } from "./RegisterChoose.vue?vue&type=template&id=19aef34c"
import script from "./RegisterChoose.vue?vue&type=script&lang=js"
export * from "./RegisterChoose.vue?vue&type=script&lang=js"
import style0 from "./RegisterChoose.vue?vue&type=style&index=0&id=19aef34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports